import { getBannerConfig } from '../api';
import { BannerConfig, ConfigTransformer, H5JumpInfo, MiniAppJumpInfo } from '../types';
import { getServerTime } from '@tencent/wphk-components-common/utils/server-time';

export const defaultTransformer: ConfigTransformer = config => config;

/**
 * 获取banner配置
 * @param bannerConfigUrl: banner配置地址
 * @returns boolean
 */
export const getConfig = async (bannerConfigUrl: string, transformer = defaultTransformer) => {
  const bannerConfigArr = await getBannerConfig(bannerConfigUrl);
  // 格式化，处理多语言
  const config: BannerConfig[] = bannerConfigArr
    // 排序
    .sort((a, b) => b.weight - a.weight)
    // 过滤出时间有效的配置
    .filter((item) => {
      // 如果未传入bannerTime，则认为该banner长期有效
      if (!item.bannerTime) {
        return true;
      }
      const { startTime } = item.bannerTime;
      const { endTime } = item.bannerTime;
      const now = getServerTime();
      return now > startTime && now < endTime;
    });
  // 可由外部注册过滤逻辑
  return transformer(config);
};
/** 是否为小程序跳转类型 */
// @ts-ignore
export const isMiniAppJumpInfo = (jumpInfo: BannerConfig['bannerJumpInfo']): jumpInfo is MiniAppJumpInfo => (!!jumpInfo?.miniAppUsername || !!jumpInfo?.miniAppId);
/** 是否为H5跳转类型 */
export const isH5JumpInfo = (jumpInfo: BannerConfig['bannerJumpInfo']): jumpInfo is H5JumpInfo => jumpInfo !== undefined && 'jumpUrl' in jumpInfo && jumpInfo.jumpUrl !== '';
